import { Position } from '@xyflow/react';

export const ATTACK_PATH_POPOVER_ESTIMATED_HEIGHT = 208;

type VerticalBounds = {
  top: number;
  bottom: number;
};

export const resolveAttackPathToolbarPosition = ({
  nodeBounds,
  containerBounds,
  popoverHeight = ATTACK_PATH_POPOVER_ESTIMATED_HEIGHT,
}: {
  nodeBounds: VerticalBounds | null;
  containerBounds: VerticalBounds | null;
  popoverHeight?: number;
}): Position => {
  if (!nodeBounds || !containerBounds) {
    return Position.Top;
  }

  const roomAbove = nodeBounds.top - containerBounds.top;

  if (roomAbove >= popoverHeight) {
    return Position.Top;
  }

  const roomBelow = containerBounds.bottom - nodeBounds.bottom;

  return roomBelow > roomAbove ? Position.Bottom : Position.Top;
};
